<template>
  <v-card flat>
    <div v-for="(item, i) in computedValue" :key="i">
      <v-card-title class="pb-2" v-text="item.name || i===0?'لوگو':i===1?'پس زمینه':''" />
      <pic-selector
        :edit-name="false"
        :field.sync="item[item.value]"
        default-cat-name="تصاویر فروشگاه"
        one-pic
        single
      />
    </div>
  </v-card>
</template>

<script>
import picSelector from "@/view/components/UploadCenter/picSelector.vue";

export default {
  name: "shopLogo",

  components: {
    picSelector,
  },

  props: {
    value: Array,
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
